import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 用户中心页面
 *
 * 包含侧边栏（导航）和内容区（slot 渲染）。
 * 通过 URL query param `?section=xxx` 控制当前激活的 section。
 *
 * 内置"个人信息"section，第三方通过 IUserCenterSlotsService 注册的 slot
 * 也会在此页面的侧边栏和内容区展示。
 */
import * as React from 'react';
import { useRoute } from '@hvsin/mod-route';
import { PROFILE_SECTION_ID } from '@hvsin/user-center-contracts';
import { Sidebar } from '../components/sidebar.js';
import { ProfilePanel } from '../components/profile-panel.js';
/**
 * 用户中心页面
 */
export function UserCenterPage({ slotsService }) {
    const [slots, setSlots] = React.useState(() => slotsService.getSlots());
    const { useSearchParams } = useRoute();
    const [searchParams] = useSearchParams();
    const activeSection = searchParams.get('section') || PROFILE_SECTION_ID;
    // ─── 订阅 slot 变化，触发重渲染 ───
    React.useEffect(() => {
        const unsubscribe = slotsService.subscribe(() => {
            setSlots(slotsService.getSlots());
        });
        return unsubscribe;
    }, [slotsService]);
    // ─── 根据 activeSection 决定渲染内容 ───
    const renderContent = () => {
        if (activeSection === PROFILE_SECTION_ID) {
            return _jsx(ProfilePanel, {});
        }
        const slot = slots.find(s => s.id === activeSection);
        if (slot) {
            return _jsx(slot.component, {});
        }
        // 未找到有效 section，fallback 到 profile
        return _jsx(ProfilePanel, {});
    };
    return (_jsxs("div", { style: styles.container, children: [_jsx(Sidebar, { slots: slots }), _jsx("main", { style: styles.content, children: renderContent() })] }));
}
const styles = {
    container: {
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: '#f3f4f6',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    content: {
        flex: 1,
        padding: '24px',
        overflowY: 'auto',
    },
};
//# sourceMappingURL=user-center-page.js.map